module.exports = __webpack_public_path__ + "static/media/coco.66c5debe.webp";